export const PITOOLS_SIM_URL = 'https://sim.amazon.com/issues/create?template=ea469bb9-e145-4508-a1a4-e8442ec359a1';

export const PITOOLS_GETTING_STARTED_URL = "https://w.amazon.com/bin/view/ProfitIntelligence/PITools/Accuracy_Analytics/";

export const SPOTLIGHT_GETTING_STARTED_URL = "https://w.amazon.com/bin/view/ProfitIntelligence/SpotCP/SpotLight/";

export const COMPONENT_DOCUMENTATION_BASE_URL = 'https://w.amazon.com/bin/view/ProfitIntelligence/HistoricalCP';

// From https://w.amazon.com/bin/view/ProfitIntelligence/ContributionProfit
export const COMPONENT_TO_LINK = Object.freeze({
  // GMS
  GMS: `${COMPONENT_DOCUMENTATION_BASE_URL}/GMS`,
  TOTAL_GMS: `${COMPONENT_DOCUMENTATION_BASE_URL}/GMS`,

  // Net Revenue
  REVENUE_SHARE: `${COMPONENT_DOCUMENTATION_BASE_URL}/RevenueShare`,
  SHIPPING_REVENUE: `${COMPONENT_DOCUMENTATION_BASE_URL}/ShippingRevenue`,
  SALES_DISCOUNTS: `${COMPONENT_DOCUMENTATION_BASE_URL}/SalesDiscounts`,
  SUBSCRIPTION_REVENUE: `${COMPONENT_DOCUMENTATION_BASE_URL}/SubscriptionRevenue`,
  CLOSING_FEES: `${COMPONENT_DOCUMENTATION_BASE_URL}/ClosingFees`,
  FULFILLMENT_FEES: `${COMPONENT_DOCUMENTATION_BASE_URL}/FulfillmentFees`,
  REFUNDS_REVENUE: `${COMPONENT_DOCUMENTATION_BASE_URL}/RefundsCost`,
  GIFTWRAP_REVENUE: `${COMPONENT_DOCUMENTATION_BASE_URL}/GiftWrapRevenue`,
  LIQUIDATION_REVENUE: `${COMPONENT_DOCUMENTATION_BASE_URL}/LiquidationRevenue`,
  WD_LIQUIDATION_REVENUE: `${COMPONENT_DOCUMENTATION_BASE_URL}/WDLiquidationRevenue`,
  OTHER_REVENUE: `${COMPONENT_DOCUMENTATION_BASE_URL}/OtherRevenue`,
  DISPLAY_ADS: `${COMPONENT_DOCUMENTATION_BASE_URL}/DisplayAds`,

  // Cost of Goods Sold (COGS)
  PRODUCT_COGS: `${COMPONENT_DOCUMENTATION_BASE_URL}/ProductCost`,
  SHIPPING_COST: `${COMPONENT_DOCUMENTATION_BASE_URL}/ShippingCost`,
  VENDOR_ALLOWANCES: `${COMPONENT_DOCUMENTATION_BASE_URL}/ContraCOGS`,
  DISCRETIONARY_COOP: `${COMPONENT_DOCUMENTATION_BASE_URL}/ContraCOGS`,
  QUICK_PAY_DISCOUNTS: `${COMPONENT_DOCUMENTATION_BASE_URL}/QuickPayDiscounts`,
  VENDOR_RETURNS: `${COMPONENT_DOCUMENTATION_BASE_URL}/VendorReturns`,
  INBOUND_FREIGHT: `${COMPONENT_DOCUMENTATION_BASE_URL}/InboundFreight`,
  FREE_REPLACEMENT_COST: `${COMPONENT_DOCUMENTATION_BASE_URL}/FreeReplacementCost`,
  REFUNDS_COST: `${COMPONENT_DOCUMENTATION_BASE_URL}/RefundsCost`,
  GIFTWRAP_COGS: `${COMPONENT_DOCUMENTATION_BASE_URL}/GiftWrapRevenue`,
  COGS_ADJUSTMENTS: `${COMPONENT_DOCUMENTATION_BASE_URL}/COGSAdjustmentsPPV`,
  LIQUIDATION_COGS: `${COMPONENT_DOCUMENTATION_BASE_URL}/LiquidationRevenue`,
  WD_LIQUIDATION_COST: `${COMPONENT_DOCUMENTATION_BASE_URL}/WDLiquidationRevenue`,
  SELLER_CREDITS: `${COMPONENT_DOCUMENTATION_BASE_URL}/SellerCredits`,
  OTHER_COSTS: `${COMPONENT_DOCUMENTATION_BASE_URL}/OtherCost`,

  // Variable Operating Expense (OPEX)
  VARIABLE_FC_COSTS: `${COMPONENT_DOCUMENTATION_BASE_URL}/VariableFC`,
  VARIABLE_CS_COSTS: `${COMPONENT_DOCUMENTATION_BASE_URL}/VariableCSCost`,
  ASSOCIATE_FEES: `${COMPONENT_DOCUMENTATION_BASE_URL}/AssociateFees`,
  SPONSORED_LINK_FEES: `${COMPONENT_DOCUMENTATION_BASE_URL}/SponsoredLinkCost`,
  PAYMENT_FEES: `${COMPONENT_DOCUMENTATION_BASE_URL}/PaymentFees`,
  BAD_DEBT: `${COMPONENT_DOCUMENTATION_BASE_URL}/BadDebt`,

  // FC Fixed
  STORAGE_AND_THROUGHPUT: 'https://w.amazon.com/bin/view/ProfitIntelligence/HistoricalFCFixed',
});



// WEBPACK FOOTER //
// ./src/constants/urls.jsx